module.exports = "<div class=\"canvasWrapper\" #wrapper>\n  <canvas #canvas id=\"canvas\"></canvas>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/charts/period-bar-chart/period-bar-chart.component.html
// module id = ../../../../../src/app/components/charts/period-bar-chart/period-bar-chart.component.html
// module chunks = main